import React from 'react';
import { TREATMENT_OPTIONS } from '../customsTreatments';
import './SizeFilter.css';

/* Border-treatment toggles for the sidebar: keep traders whose goods might
 * need ANY selected treatment. Nothing selected = any. Same look as SizeFilter. */
const CustomsFilter = ({ value = [], onChange }) => {
    const toggle = (key) =>
        onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key]);
    return (
        <div className="size-filter" role="group" aria-label="Might need at the border">
            {TREATMENT_OPTIONS.map((o) => (
                <button
                    key={o.key}
                    type="button"
                    title={o.hint}
                    aria-pressed={value.includes(o.key)}
                    className={value.includes(o.key) ? 'on' : ''}
                    onClick={() => toggle(o.key)}
                >
                    {o.label}
                </button>
            ))}
        </div>
    );
};

export default CustomsFilter;
